import { createSelector } from '@reduxjs/toolkit'
import { createStructuredSelector } from 'reselect'

import { extractFabrication } from '../utils/extracter';

const selectFabricationParameters = (state) => state.fabrication?.parameters;
const selectFabricationParametersChanged = (state) => state.fabrication?.parametersChanged;
const selectFabricationQuoteStep = (state) => state.fabrication?.quoteStep;
const selectFabricationQuote = (state) => state.fabrication?.quote;
const selectFabricationDestroy = (state) => state.fabrication?.destroy;
const selectFabricationLineItemId = (state) => state.fabrication?.lineItemId;
const selectFabricationCustomQuoteRequest = (state) => state.fabrication?.customQuoteRequest;
const selectFabricationNeedCustomQuote = (state) => state.fabrication?.needCustomQuote;
const selectFabricationValidationFlag = (state) => state.fabrication?.validatorFlag;

export const selectFabricationCurrentVariant = (state) => state.fabrication?.currentVariant;
export const selectFabricationLoading = (state) => state.fabrication?.loading;

export const selectFabricationDataForParameters = createStructuredSelector({
  customQuoteRequest: selectFabricationCustomQuoteRequest,
  needCustomQuote: selectFabricationNeedCustomQuote,
  parameters: selectFabricationParameters,
  validatorFlag: selectFabricationValidationFlag,
})

export const selectFabricationDataForPrices = createStructuredSelector({
  quoteStep: selectFabricationQuoteStep,
  quote: selectFabricationQuote,
  parameters: selectFabricationParameters,
  parametersChanged: selectFabricationParametersChanged,
})

export const selectFabricationDataForCart = createSelector([
  selectFabricationParameters,
  selectFabricationQuoteStep,
  selectFabricationQuote,
  selectFabricationCurrentVariant,
  selectFabricationDestroy,
  selectFabricationLineItemId,
  ], (
    parameters,
    quoteStep,
    quote,
    currentVariant,
    destroy,
    lineItemId,
  ) => {

      const items_to_destroy = destroy && lineItemId ? [lineItemId] : [];
      const data_for_forms = {quoteStep, variantId: currentVariant, parameters}

      return{
        partNumber: parameters?.part_number,
        revision: parameters?.revision,
        fabProps: extractFabrication({parameters, quoteStep, quote}),
        fabToDestroy: items_to_destroy,
        fabDataForForms: data_for_forms,
      }
  }
);